export default function Security() {
  return (
    <section id="bezpieczenstwo" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-600 mb-4">
            <i className="ri-shield-check-line"></i> Bezpieczeństwo
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Bezpieczeństwo korzystania z{' '}
            <span className="italic text-primary-500">Kakobuy Spreadsheet</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            Twoje bezpieczeństwo jest dla nas priorytetem. Przestrzegaj tych zasad, aby bezpiecznie korzystać z arkusza produktów.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            {
              icon: "ri-error-warning-line",
              title: "Unikaj fałszywych stron",
              desc: "Korzystaj wyłącznie z oficjalnych linków z Kakobuy Spreadsheet. Nie klikaj w podejrzane linki otrzymane z nieznanych źródeł.",
            },
            {
              icon: "ri-link",
              title: "Weryfikuj adresy URL",
              desc: "Zawsze sprawdzaj, czy adres strony zaczyna się od prawidłowej domeny przed dokonaniem zakupu lub podaniem danych.",
            },
            {
              icon: "ri-lock-line",
              title: "Chroń dane osobowe",
              desc: "Nie udostępniaj swoich danych osobowych na niesprawdzonych stronach. Kakobuy Spreadsheet nie wymaga podawania wrażliwych informacji.",
            },
            {
              icon: "ri-key-2-line",
              title: "Nie udostępniaj haseł",
              desc: "Nigdy nie podawaj swoich haseł osobom trzecim. Żaden administrator Kakobuy Spreadsheet nie poprosi Cię o hasło.",
            },
          ].map((item, idx) => (
            <div key={idx} className="flex gap-4 bg-background-50 rounded-2xl p-5 border border-background-200/60">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}